{
  "version": 1,
  "asset_id": "7c3b5c43-2445-4824-8694-f4d2906cf21a",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/7c3b5c43-2445-4824-8694-f4d2906cf21a/svc-link-building-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/7c3b5c43-2445-4824-8694-f4d2906cf21a/svc-link-building-640.webp",
  "original_filename": "svc-link-building-640.webp",
  "size": 7430,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:50Z"
}
